import React from 'react';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = ['Ejercicios listos para usar', 'Sistema de recuperación y prevención de lesiones', 'Nutrición y energía para hockey'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#223322]" data-id="element-11">
      <div className="max-w-5xl mx-auto" data-id="element-12">
        <div className="text-center mb-16" data-id="element-13">
          <h2 className="font-heading text-4xl md:text-5xl font-bold mb-6 text-[#c8e6c9]" data-id="element-14">
            Bonos GRATIS por el día de hoy
          </h2>
          <p className="text-xl text-[#a8c5a8]" data-id="element-15">
            Estos bonos complementarios se suman a tu compra sin costo adicional
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-16">
          {bonuses.map((bonus, index) => <div key={index} className="bg-[#1a2e1a] rounded-2xl p-8 border border-[#2e7d32]/40 relative overflow-hidden group hover:border-[#4caf50] transition-colors" data-id="element-17">
              <div className="absolute top-0 right-0 bg-[#2e7d32] text-[#faf5e8] text-xs font-bold px-3 py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-18">
                Bono Gratis
              </div>

              <div className="w-16 h-16 bg-[#2e7d32]/15 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-19">
                <Gift className="w-8 h-8 text-[#4caf50]" data-id="element-20" />
              </div>

              <p className="text-sm text-[#4caf50] font-bold mb-2 uppercase tracking-wider" data-id="element-21">
                Bono {index + 1}
              </p>
              <h3 className="font-heading text-xl font-bold text-[#faf5e8] leading-snug" data-id="element-22">
                {bonus}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}